
<template>
  <el-dialog
    title="更改项目关联用户"
    :visible.sync="showDialog"
    :before-close="handleClose"
    width="600px"
    class="change-users-dialog"
    :destroy-on-close="true"
  >
    <el-form v-loading="loading" ref="form" :model="form" :rules="rules" label-width="90px" class="user-form">
      <!-- 分析人员 -->
      <el-form-item label="分析人员" prop="analystUuid">
        <el-select
          v-model="form.analystUuid"
          filterable
          clearable
          placeholder="请选择分析人员"
          class="full-width"
        >
          <el-option
            v-for="item in analystList"
            :key="item.uuid"
            :label="item.name"
            :value="item.uuid"
          >
            <span>{{ item.name }}</span>
            <span class="option-extra">{{ item.phone || '' }}</span>
          </el-option>
        </el-select>
      </el-form-item>

      <!-- 销售人员 -->
      <el-form-item label="销售人员" prop="salesUuids">
        <el-select
          v-model="form.salesUuids"
          filterable
          clearable
          placeholder="请选择销售人员"
          class="full-width"
        >
          <el-option
            v-for="item in salesList"
            :key="item.uuid"
            :label="item.name"
            :value="item.uuid"
          >
            <span>{{ item.name }}</span>
            <span class="option-extra">{{ item.phone || '' }}</span>
          </el-option>
        </el-select>
      </el-form-item>

      <!-- 客户管理 -->
      <el-form-item label="客户" prop="customerIds" >
        <el-select
          class="full-width"
          v-model="form.customerIds"
          filterable
          multiple
          placeholder="请选择客户邮箱"
          remote
          :remote-method="remoteType"
          @change="changeEmail"
          value-key="id"
        >
          <el-option
              v-for="item in customerList"
              :key="item.id"
              :label="item.emailAccount"
              :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div class="tips-box">
      <i class="el-icon-info"></i>
      <span>更换的客户必须在系统内；若不在，请前往"客户管理"添加客户</span>
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" :loading="buttonLoading" @click="handleSubmit">
        确 定
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import {requestCustomerList, requestUserList, userList} from "../api/user";
import { requestProjectEditPersonnel } from "../api/project";

export default {
  name: "ChangeUsersDialog",
  props: {
    showDialog: {
      type: Boolean,
      default: false
    },
    selectDetail: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      buttonLoading: false,
      loading:false,
      analystList: [],    // 分析人员列表
      salesList: [],      // 销售人员列表
      customerList:[],
      form: {
        projectId: "",
        analystUuid: "",
        salesUuids: [],
        customerIds: []
      },
      rules: {
        analystUuid: [
          { required: true, message: "请选择分析人员", trigger: "change" }
        ],
        salesUuids: [
          { required: true, message: "请选择销售人员", trigger: "change" }
        ],
        customerIds: [
          { required: true, message: "请选择客户", trigger: "change" }
        ]
      },
    };
  },
  watch: {
    showDialog: {
      handler(val) {
        if (val) {
          this.initData();
        }
      },
      immediate: true
    }
  },
  methods: {
    // 初始化表单数据
    async initData() {
      const detail = this.selectDetail || {};
      this.form.projectId = detail.projectId || "";
      this.form.analystUuid = detail.analystUuid || "";
      this.form.salesUuids = detail.salesUuids || [];

      // 处理客户回显：提取客户ID数组
      const customers = detail.customers || [];
      this.form.customerIds = customers.map(item => item.id);

      // 将已选中的客户数据添加到customerList中以实现回显
      if (customers.length > 0) {
        this.customerList = [...customers];
      }
      this.fetchUserList();
    },

    // 获取人员列表
    async fetchUserList() {
      this.loading=true
      const params = { 'page.current': 1, 'page.size': 500 };
      // 并行请求分析人员和销售人员
      const [analystRes, salesRes] = await Promise.all([
        requestUserList('ANALYST', params, {}),
        requestUserList('SALES', params, {})
      ]);
      if (analystRes?.code === 200) {
        this.analystList = analystRes.data?.records || [];
      }
      if (salesRes?.code === 200) {
        this.salesList = salesRes.data?.records || [];
      }
      this.loading=false
    },
    remoteType(query) {
      if (query) {
        this.getCustomerList({ emailAccount: query });
      }
    },
    changeEmail(selectedIds) {
      // 搜索时保留已选中的客户
      const selectedCustomers = this.customerList.filter(item => selectedIds.includes(item.id));
      this.getCustomerList({}, selectedCustomers);
    },
    getCustomerList(sendData, keepCustomers = []) {
      requestCustomerList({ 'page.current': 1, 'page.size': 200 }, sendData).then(res => {
        if (res.code === 200) {
          const newRecords = res.data.records || [];
          // 合并已选中的客户和新搜索的客户，去重
          const mergedList = [...keepCustomers];
          newRecords.forEach(item => {
            if (!mergedList.some(c => c.id === item.id)) {
              mergedList.push(item);
            }
          });
          this.customerList = mergedList;
        }
      });
    },
    // 关闭弹窗
    handleClose() {
      this.$emit("update:showDialog");
    },
    // 提交
    async handleSubmit() {
      this.$refs.form.validate(async valid => {
        if (!valid){
          this.$messageUi.error('填写参数不规范，请检查');
          return;
        }
        try {
          this.buttonLoading = true;
          const submitData = {
            projectId: this.form.projectId,
            analystUuid: this.form.analystUuid,
            salesUuid: this.form.salesUuids,
            customerIds: this.form.customerIds
          };
          const res = await requestProjectEditPersonnel(submitData);
          if (res?.code === 200) {
            this.$messageUi.success("用户信息更新成功");
            this.$emit("submit", submitData);
            this.handleClose();
          } else {
            this.$messageUi.error(res?.message || "操作失败");
          }
        } catch (error) {
          this.$messageUi.error("操作失败，请重试");
        } finally {
          this.buttonLoading = false;
        }
      });
    }
  }
};
</script>

<style scoped>
.change-users-dialog /deep/ .el-dialog__body {
  padding: 20px 25px;
}

.user-form {
  margin-bottom: 10px;
}

.full-width {
  width: 100%;
}

.option-extra {
  color: #909399;
  font-size: 12px;
  margin-left: 10px;
}

.customer-section {
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  padding: 12px;
  background: #fafafa;
}

.customer-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 12px;
}

.customer-tag {
  max-width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.empty-tip {
  color: #909399;
  font-size: 13px;
  margin-bottom: 12px;
}

.add-customer {
  display: flex;
}

.add-customer /deep/ .el-input-group__append {
  background: #409eff;
  border-color: #409eff;
  color: #fff;
}

.tips-box {
  background: #fdf6ec;
  border-radius: 4px;
  padding: 10px 15px;
  color: #e79213;
  font-size: 13px;
  display: flex;
  align-items: center;
}

.tips-box i {
  margin-right: 8px;
}

.dialog-footer {
  text-align: right;
}
</style>
